<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              name="price"
              label="قیمت"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.price"
            />
            <bita-input
              name="net_price"
              label="قیمت صافی"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.net_price"
            />
            <bita-input
              name="amount_payable"
              label="مبلغ قابل پرداخت"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.amount_payable"
              :disabled="true"
            />
            <bita-input
              name="loading_fee"
              label="هزینه بارگیری"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.loading_fee"
              :disabled="true"
            />
            <bita-input
              name="temprory_fee"
              label="علی الحساب"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.temprory_fee"
              :disabled="true"
            />
            <bita-input
              name="comission_fee"
              label="هزینه کمیسیون"
              :validation-container-class="colWidth"
              input-class="form-control"
              :has-thousand-seprator="true"
              v-model="updateData.comission_fee"
              :disabled="true"
            />
            <bita-input
              name="output_remittance_number"
              label="شماره حواله خروجی"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="updateData.output_remittance_number"
            />
            <bita-input
              name="cargo_state"
              label="وضعیت بارنامه"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="updateData.cargo_state ? 'دارد' : 'ندارد'"
              :disabled="true"
            />
            <bita-select
              name="loadParent"
              label="دسته بندی نوع بار"
              ref="parentLoadId"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="propsParentLoad"
              data-text-field="name"
              data-value-field="id"
              v-model="updateData.loadParentId"
              @change="getLoadChild"
            />
            <Spinner
              :is-loading="isLoadingLoadChild"
              class-name="col-lg-4 col-md-6 col-sm-6"
              styleName="align-self: center;"
            />
            <bita-select
              v-if="isLoadingLoadChild === false"
              name="load"
              label="نوع بار"
              ref="loadId"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="loadChild"
              data-text-field="name"
              data-value-field="id"
              v-model="updateData.load_id"
            />
            <bita-select
              name="state"
              label="وضعیت این بار"
              ref="stateId"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="propsRequestDetailState"
              data-text-field="name"
              data-value-field="id"
              v-model="updateData.state_id"
              :disabled="true"
            />
            <bita-select
              name="customer"
              label="مشتری"
              ref="customerId"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="propsCustomer"
              data-text-field="name"
              data-value-field="id"
              v-model="updateData.customer_id"
            />
            <bita-select
              name="carrier"
              label="باربری"
              ref="carrierId"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="propsCarrier"
              data-text-field="name"
              data-value-field="id"
              v-model="updateData.carrier_id"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="success"
        title="لغو این بار برای راننده"
        icon="fa fa-check"
        btn-width="250px"
        @click.native="cancelRequestDetail()"
        class="ml-2"
      />
      <bita-bootbutton
        type="primary"
        title="به روز رسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleUpdate()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {},
    propsParentLoad: {},
    propsChildLoad: {},
    propsRequestDetailState: {},
    propsCustomer: {},
    propsCarrier: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      isDisabled: false,
      updateData: [],
      loadParent: {},
      loadChild: {},
      isLoadingVehicleTypes: false,
      isLoadingLoadChild: false,
    };
  },
  watch: {
    propsData: function(_data) {
      this.updateData = _data;
    },
    propsChildLoad: function(_data) {
      this.loadChild = _data;
    },
  },
  methods: {
    handleUpdate() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.updateData);
        }
      });
    },
    cancelRequestDetail() {
      this.isLoadingModal = true;
      this.$persistClient(
        "patch",
        `request-details/${this.updateData.id}/cancel`
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.$emit("on-cancel");
        });
    },
    getLoadChild(e) {
      this.isLoadingLoadChild = true;
      this.$persistClient("get", `loads?filter[parentItem]=${e}`)
        .then((res) => {
          this.loadChild = res.data;
        })
        .finally(() => {
          this.isLoadingLoadChild = false;
        });
    },
  },
};
</script>
